// extracted by mini-css-extract-plugin
export default {"bar":"Ruler_bar__gUqka","scale":"Ruler_scale__qj0xh","division":"Ruler_division__W81G8"};